import type { TemplateUsage } from '@/api/v2Client';

/**
 * Tracker row 10 — what the delete dialog says, from the template's real usage
 * (the same evaluator the server's DELETE guard uses). Unused templates keep
 * the original wording.
 */
export function deleteDialogMessage(name: string, usage: TemplateUsage | 'unknown' | null): string {
  const recoverable = `It disappears from this list but is kept: you can bring it back any time via "Show deleted" → Restore.`;
  if (usage === null) return `Checking which submissions use "${name}"…`;
  if (usage === 'unknown') {
    return `Delete template "${name}"? Could not check which submissions use it — if an active submission does, the delete will be refused. ${recoverable}`;
  }
  const names = (list: TemplateUsage['submissions']): string => list.map((s) => s.name).join('; ');
  if (usage.activeCount > 0) {
    const active = usage.submissions.filter((s) => !s.isLocked);
    return (
      `"${name}" is used by ${usage.totalCount} submission(s), ${usage.activeCount} of them active: ${names(active)}. ` +
      `It cannot be deleted while active submissions use it — remove it from those submissions first.`
    );
  }
  if (usage.totalCount > 0) {
    return (
      `Delete template "${name}"? It is used by ${usage.totalCount} submission(s), all locked or completed: ` +
      `${names(usage.submissions)}. They keep the copies they already generated. ${recoverable}`
    );
  }
  return `Delete template "${name}"? ${recoverable} Submissions keep their generated copies either way.`;
}
